export const ENTITY_OUTLINE_WIDTH_RATIO = 0.14;
export const ENTITY_OUTLINE_MIN_WIDTH = 1.75;
export const ENTITY_OUTLINE_MAX_WIDTH = 7;
export const ENTITY_OUTLINE_DARKEN_FACTOR = 0.55;

export function entityOutlineWidth(size: number): number {
  return clamp(size * ENTITY_OUTLINE_WIDTH_RATIO, ENTITY_OUTLINE_MIN_WIDTH, ENTITY_OUTLINE_MAX_WIDTH);
}

export function entityOutlineColor(fillColor: string): string {
  return darkenCssColor(fillColor, ENTITY_OUTLINE_DARKEN_FACTOR);
}

function darkenCssColor(color: string, factor: number): string {
  const rgb = parseCssColor(color);

  if (!rgb) {
    return color;
  }

  return `rgb(${Math.round(rgb.r * factor)}, ${Math.round(rgb.g * factor)}, ${Math.round(rgb.b * factor)})`;
}

function parseCssColor(color: string): { r: number; g: number; b: number } | null {
  const trimmed = color.trim();
  const hexMatch = trimmed.match(/^#([0-9a-f]{6})$/i);

  if (hexMatch) {
    const value = Number.parseInt(hexMatch[1] ?? "0", 16);

    return {
      r: (value >> 16) & 255,
      g: (value >> 8) & 255,
      b: value & 255
    };
  }

  const rgbMatch = trimmed.match(
    /^rgb\(\s*([0-9.]+)\s*,\s*([0-9.]+)\s*,\s*([0-9.]+)\s*\)$/i
  );

  if (!rgbMatch) {
    return null;
  }

  return {
    r: clampColor(Number(rgbMatch[1])),
    g: clampColor(Number(rgbMatch[2])),
    b: clampColor(Number(rgbMatch[3]))
  };
}

function clampColor(value: number): number {
  if (!Number.isFinite(value)) {
    return 0;
  }

  return Math.max(0, Math.min(255, value));
}

function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}